// common/services/player/inviteFamilyContact.ts
import req from '../../api/request'
import { familyInvitePath, type FamilyScope } from './familyScope'

export type InviteFamilyContactInput = {
  /** Player whose family the contact is being invited to. */
  playerId: string
  /** Given name for the new contact. */
  name_first: string
  /** Family name for the new contact. */
  name_last: string
  email: string
  /** E.164 phone number (e.g. '+14165550123'). Optional per the design. */
  phone_number?: string | null
  /**
   * BE relationship type id (RelationshipType). Omitted/null when the user
   * leaves the dropdown blank so the backend can apply its default.
   */
  relationship_type_id?: number | null
  /** Whether the contact gets administrative access to the player. */
  is_primary?: boolean
  /** Which backend routes to use. Omitted → self-scoped ('me'). */
  scope?: FamilyScope
}

export type InviteFamilyContactResponse = {
  id?: string
  status?: 'sent' | 'pending'
} & Record<string, unknown>

/**
 * POST a family-contact invitation (route chosen by `scope`).
 * Body: { name_first, name_last, email, phone_number?, relationship_type_id? }.
 */
export const inviteFamilyContact = async (
  input: InviteFamilyContactInput
): Promise<InviteFamilyContactResponse> => {
  const { playerId, scope, ...body } = input
  const { data } = await req(familyInvitePath(playerId, scope), {
    method: 'POST',
    body: JSON.stringify(body),
  })
  return data as InviteFamilyContactResponse
}
